export const COURSES = [];
export function courseById(id) {
    return COURSES.find((c) => c.id === id);
}
export function generateCourse(enabled, length, tempoBpm, windowMs) {
    const pool = enabled.length > 0 ? enabled : ["hum"];
    const sequence = [];
    for (let i = 0; i < Math.max(1, length); i++) {
        sequence.push(pool[i % pool.length]);
    }
    for (let i = sequence.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [sequence[i], sequence[j]] = [sequence[j], sequence[i]];
    }
    if (new Set(pool).size > 1) {
        for (let i = 1; i < sequence.length; i++) {
            if (sequence[i] !== sequence[i - 1])
                continue;
            let swapped = false;
            for (let k = i + 1; k < sequence.length; k++) {
                const prev = sequence[i - 1];
                const next = sequence[i + 1];
                if (sequence[k] !== prev && sequence[k] !== next) {
                    [sequence[i], sequence[k]] = [sequence[k], sequence[i]];
                    swapped = true;
                    break;
                }
            }
            void swapped;
        }
    }
    return {
        id: "custom",
        title: "Custom Mix",
        blurb: "A generated run from your enabled sounds.",
        sequence,
        tempoBpm,
        windowMs,
    };
}
